import dashboardRequest from '../utils/dashboardRequest';

// 拉取 dashboard详情接口, 包含有哪些筛选器, 以及筛选器选项和默认值
export const getDatalabDashboardDetail: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/datalab/getDashboardDetail',
    method: 'post',
    data
  });
};

//
export const getFilterOptions: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/datalab/getChartDimension',
    method: 'post',
    data
  });
}

// 表格接口
export const getDatalabAnalysisDashboard: (data: string) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/datalab/analysis_dashboard',
    method: 'post',
    data
  });
}

// 图表接口, 包含折线图, 堆叠柱状图, 饼图数据, 以及维度指标下拉选项
export const getDatalabAnalysisDashboardChart: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/datalab/analysis_dashboard_chart',
    method: 'post',
    data: data,
  }
  return dashboardRequest(options)
}

// 包含 包含折线图, 堆叠柱状图, 饼图数据, 以及维度指标下拉选项, 还有表格数据
export const getDatalabAnalysisDashboardChartAll: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/datalab/analysis_dashboard_full',
    method: 'post',
    data
  });
};

// 下载接口
export const getDatalabAnalysisDashboardDownload: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/datalab/analysis_dashboard_download',
    method: 'post',
    data: data,
    rawData:true,
    responseType: 'arraybuffer',
  }
  return dashboardRequest(options)
}
